<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Solicitud de fondo a rendir
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Finanzas</span>
      <span> /</span>
      <span>Solicitud de fondo a rendir</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-body">
      <div class="col dato" style="max-width: 200px;">
        <Strong class="title">Nro. ID</Strong>
        <span class="value">AP-1001</span>
      </div>
      <div class="col dato" style="max-width: 200px;">
        <Strong class="title">Usuario</Strong>
        <span class="value">Juan Pérez</span>
      </div>
      <div class="col dato" style="max-width: 200px;">
        <Strong class="title">Fecha</Strong>
        <span class="value">dd/mm/aaaa</span>
      </div>
      <div class="col dato" style="max-width: 200px;">
        <Strong class="title">Hora</Strong>
        <span class="value">hh:mm</span>
      </div>
    </div>
    <div class="row filtros-body align-items-center">
      <div class="col" style="max-width: 300px;">
        <div class="md-form">
          <mdb-select
            label="Seleccionar Tipo movimiento"
            [options]="optionsTipoMov"
            placeholder="Seleccionar Tipo movimiento"
            [filterEnabled]="true"
          ></mdb-select>
        </div>
      </div>
      <div class="col d-flex" style="max-width: 300px;">
        <button
          mdbBtn
          type="button"
          class="btn-cuadrado"
          color="secondary"
          mdbWavesEffect
          (click)="seleccionarCentroGasto.show()"
        >
          <mdb-icon fas icon="search"></mdb-icon>
        </button>
        <h6 class="text-info" style="display: contents;">
          Centro de gasto
        </h6>
      </div>
      <div class="col">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="concepto"
            class="form-control"
            placeholder="Conceptos"
            required
            #concepto
          />
          <label for="concepto">Conceptos</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="montorEntregar"
            class="form-control"
            placeholder="9.000"
            required
            #montorEntregar
          />
          <label for="montorEntregar">Monto a entregar</label>
        </div>
      </div>
    </div>
    <div class="row filtros-body align-items-center">
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="solicitadoPor"
            class="form-control"
            placeholder="Solicitado por"
            required
            #solicitadoPor
          />
          <label for="solicitadoPor">Solicitado por</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="rutSolicitadoPor"
            class="form-control"
            placeholder="9.999.999-9"
            required
            #rutSolicitadoPor
          />
          <label for="rutSolicitadoPor">RUT</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="entregadoA"
            class="form-control"
            placeholder="9.000"
            required
            #entregadoA
          />
          <label for="entregadoA">Entregado a</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="rutEntregadoA"
            class="form-control"
            placeholder="9.999.999-9"
            required
            #rutEntregadoA
          />
          <label for="rutEntregadoA">RUT</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6;"
  >
    <div></div>
    <button size="sm" class="btn btn-sm" mdbBtn type="button" color="success" mdbWavesEffect>
      Aperturar
    </button>
  </div>
</div>

<!-- MODAL seleccionarCentroGasto -->
<div
  mdbModal
  #seleccionarCentroGasto="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar centro de gasto
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="seleccionarCentroGasto.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col dato">
            <div class="md-form">
              <input
                value=""
                type="text"
                id="descRecorrido"
                class="form-control"
                placeholder="Descripción o Código"
                required
                #descRecorrido
              />
              <label for="descRecorrido">Centro de gasto</label>
            </div>
          </div>
        </div>

        <div
          class="row justify-content-between"
          style="border-top: 1px solid #dee2e6;"
        >
          <div></div>
          <button mdbBtn type="button" color="info" mdbWavesEffect>
            <mdb-icon fas icon="search"></mdb-icon>
            Buscar
          </button>
        </div>

        <table
          class="table table-striped table-hover table-sm align-middle mt-1"
        >
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Código</th>
              <th scope="col">Descripción</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>21</td>
              <td>Descripción</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarCentroGasto.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>010</td>
              <td>Descripción</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>1111</td>
              <td>Descripción</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
